export class Eventi {
    descrizione: string = null;
    icona: string = null;
    id: number = null;
    main_event: boolean = null;
    abbreviazione: string = null;
}

export enum TIPI_EVENTO {
    Gol = 1,
    Ammonizione = 2,
    Espulsione = 3,
    Cambio = 4,
    Autogol = 5,
    Fallo = 6,
    Corner = 7,
    Tiro_fuori = 8,
    Tiro_parato = 9,
    Tiro_respinto = 10,
    Palo = 11,
    Traversa = 12,
    Rigore = 13,
    Punizione = 14,
    Resoconto_libero = 15,
    Rigore_fallito = 16
}


// WEBPACK FOOTER //
// ./src/app/shared/models/eventi.ts